import { render, staticRenderFns } from "./LivestockRecord.vue?vue&type=template&id=e2624dc8&scoped=true&"
import script from "./LivestockRecord.vue?vue&type=script&lang=js&"
export * from "./LivestockRecord.vue?vue&type=script&lang=js&"
import style0 from "./LivestockRecord.vue?vue&type=style&index=0&id=e2624dc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2624dc8",
  null
  
)

export default component.exports